import type { BulkLogStatus } from "../types";

export const LOG_STATUS_OPTIONS: { key: BulkLogStatus; label: string; className: string }[] = [
  { key: "PROCESSING", label: "Processing", className: "tw-bg-blue-50 tw-text-blue-700" },
  { key: "COMPLETED", label: "Pending confirmation", className: "tw-bg-amber-50 tw-text-amber-700" },
  { key: "CONFIRMED", label: "Confirmed", className: "tw-bg-green-50 tw-text-green-700" },
  { key: "FAILED", label: "Failed", className: "tw-bg-red-50 tw-text-red-700" },
];

export const UPLOADED_ON_SORT_KEY = "created_at";

// ReactTableTrademo resolves a clicked header back to its sort value through
// this list (its `shipmentDefaultSortValue` prop).
export const LOG_SORT_OPTIONS = [{ columnKey: UPLOADED_ON_SORT_KEY, value: UPLOADED_ON_SORT_KEY }];

// Rows fetched per request; the backend caps size at 100.
export const LOGS_FETCH_SIZE = 100;
